import React from 'react';

import type { ErrorType } from './types';

type ErrorContextProps = {
  message: string,
  show: boolean,
  showError: ({ message, error }: { message?: string, error?: ErrorType }) => void
}

const ErrorContext = React.createContext<ErrorContextProps>({
  message: '',
  show: false,
  showError: () => { },
});

export default ErrorContext;
